// CSS
import "../../general.css";
import "../newStudentForm.css";

// Functions
import { getDaysString } from "../NewStudentForm";
import { getHourString } from "../../../backend/timeFunctions";

// Bootstrap
import Button from "react-bootstrap/Button";

// Icons
import { FiCalendar, FiClock, FiMapPin } from "react-icons/fi";

export const WelcomePhase = (props) => {
  const groupData = props.groupData;
  const setProgress = props.setProgress;

  return (
    <div className="welcome-phase phase-transition">
      <h1 className="text-center mb-4">ברוכים הבאים לטופס הרישום</h1>

      <div className="group-info-card">
        <h2 className="text-center mb-4">
          {`קבוצת ה${groupData?.name} ב${groupData?.dojo}`}
        </h2>

        <div className="info-items">
          {!groupData?.trainingSlots ? (
            <div className="info-item">
              <FiClock className="info-icon" />
              <span>{`${getHourString(groupData.startTime)} - ${getHourString(
                groupData.endTime
              )}`}</span>
            </div>
          ) : null}

          <div className="info-item">
            <FiMapPin className="info-icon" />
            <span>{groupData?.dojo}</span>
          </div>

          <div className="info-item">
            <FiCalendar className="info-icon" />
            <div className="training-days">
              {getDaysString(groupData)
                .split("&")
                .map((row, index) => (
                  <div key={index} className="training-day">
                    {row}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <Button
          variant="primary"
          className="btn btn-primary btn-lg"
          onClick={() => setProgress(2)}
        >
          בואו נתחיל
        </Button>
      </div>
    </div>
  );
};
